import React from 'react'

export default function StepList({ steps = [] }) {
  if (!steps || steps.length === 0) return null
  return (
    <ol style={{ marginLeft: 18 }}>
      {steps.map((s, i) => (
        <li key={i} style={{ marginBottom: 6 }}>{s}</li>
      ))}
    </ol>
  )
}
